import React, { useEffect, useMemo, useState } from "react";

// Components
import { Helmet } from "react-helmet";

import InfoCard from "./InfoCard";
import { notification, Col, Row } from "antd";
import FulfillmentBackButton from "../../../fulfillment/FulfillmentBackButton";
import OrdersTable from "./OrdersTable";
import ShipmentsTable from "./ShipmentsTable";
import ShippingPreferences from "./ShippingPreferences";
import ProductsTable from "./ProductsTable";
import ReturnsTable from "./ReturnsTable";
import UsersTable from "./UsersTable";
import StoresTable from "./StoresTable";
import CarriersTable from "./CarriersTable";
import ASNTable from "./ASNTable";
import InventoryTransferTable from "./InventoryTransferTable";
import EventSubscriptionsTable from "./EventSubscriptionsTable";
import ShipmentMethodTable from "./ShipmentMethodTable";
import FreightcomCredentialsTable from "./FreightcomCredentialsTable";

import { ReturnPreferenceTable } from "../../../../components/ReturnPreferenceTable";
// Hooks
import { useParams } from "react-router";
import { useOrganizationContext } from "contextProviders/organization/OrganizationProvider";

// Libs
import { get } from "lodash-es";
import Organization from "lib/organization";
import {
  fallbackFulfilledFromMapping,
  FulfilledFromState,
  getFulfilledFrom,
} from "lib/fulfillment/fulfilledFromMapping";
import { useFeatureFlagQuery } from "../../../../hooks/useFeatureFlagQuery";
import { fetchFreightcomCredentials } from "api/accounts/organization_freightcom";
import { useQuery } from "react-query";

const OrganizationDetailsPage = () => {
  const organizationDetails = useOrganizationContext();
  const params = useParams();
  const organizationID = get(params, "organization_id");
  const query = {
    per_page: 5,
    organization_id: organizationID,
  };
  const showNewShipmentCreatePage = useFeatureFlagQuery("new-reverse-logistics-create-flow");

  const {
    data: freightcomCredentials,
    refetch: refetchFreightcomCredentials,
    isLoading: loadingCredentials,
  } = useQuery(["organization_fc", organizationID], () => fetchFreightcomCredentials(organizationID), {
    onError: (error: string) => {
      notification.error({
        message: "Error",
        description: error,
      });
    },
  });

  useEffect(() => {
    if (organizationDetails.error) {
      notification.error({
        message: "Error",
        description: organizationDetails.error,
      });
    }
  }, [organizationDetails.error]);

  const renderHeader = () => (
    <div className="header">
      <FulfillmentBackButton urlPath="/organizations" label="Organization Index" />
    </div>
  );

  return (
    <div id="organization-details-page" className="page-container">
      <Helmet title="Sierra - Organization Details" />
      {renderHeader()}
      <Row gutter={30}>
        <Col flex="auto">
          <InfoCard loading={organizationDetails.loading} organization={organizationDetails.data} />
        </Col>
      </Row>
      <ShipmentMethodTable
        shipmentMethods={organizationDetails.data?.recommended_shipping_methods}
        loading={organizationDetails.loading}
      />
      <UsersTable query={query} />
      <ASNTable query={query} />
      <OrdersTable query={query} />
      <ShipmentsTable query={query} />
      <ShippingPreferences organizationId={organizationID} />
      <ProductsTable query={query} />
      <InventoryTransferTable query={query} />
      {Organization.isEndy(organizationDetails.data) ? (
        <CarriersTable query={{ ...query, include_defaults: false }} />
      ) : null}
      <StoresTable query={query} />
      {/* TODO - ANNIE: revert non-vessi merchants returns */}
      <ReturnsTable query={{ organization_id: organizationID, limit: "5" }} />

      {showNewShipmentCreatePage.data?.state && (
        <ReturnPreferenceTable
          organizationId={organizationID}
          preferredReturnFacility={Organization.getPreferredReturnFacility(organizationDetails.data)}
        />
      )}
      <FreightcomCredentialsTable
        organizationID={organizationID}
        freightcomCredentials={freightcomCredentials || []}
        loading={loadingCredentials}
        refetchFreightcomCredentials={refetchFreightcomCredentials}
      />
      <EventSubscriptionsTable query={query} />
    </div>
  );
};

export default OrganizationDetailsPage;
